import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"width":_vm.width,"scrollable":""},on:{"click:outside":_vm.onClickOutside},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c(VCard,{attrs:{"color":"surface lighten-1"}},[_c(VCardTitle,[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c(VDivider),_c(VCardText,{staticClass:"custom-scrollbar intro-dialog surface"},[_vm._t("default")],2),_c(VDivider),_c(VCardActions,[_c(VSpacer),_vm._t("actions")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }